// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xDTe","tabsBox":"styles_tabsBox__2CO9K","createButton":"styles_createButton__3Dg0B"};